import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import customBuild from 'src/ckeditor5/build/ckeditor';
import { c1, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import type { EditorConfig } from '@ckeditor/ckeditor5-core';
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-button-bgcolor",
  templateUrl: "./button-bgcolor.component.html",
  styleUrls: ["./button-bgcolor.component.scss"],
})

export class ButtonBgColorComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private builderService: BuilderService

  ) { }

  lableform: UntypedFormGroup; // bootstrap validation form

  @Input() button_id: string;
  @Input() config: any;

  colors: any;
  light: boolean

  colorsComponentSubscription: any;
  imageConfig: any = {};
  button: MenuButton;
  image: string;
//
  mode: string;
  offCanvasSubscription: any;
  row_id: string;
  data: any;
  currentMenuSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button"
  component_id: string;
  field_id: string;
  start_color: string;
  end_color: string;
  isAndroid: boolean;


  ngOnInit() {
    this.field_id = 'button_bgstart_bgend'
    this.sortedButtonList = [];
    this.buttonList = {};
    this.isAndroid = localStorage.getItem("mode")[0] == c1.ANDROID ? true : false;

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.intialize(data)
        this.buttonFunction()
        }
      }
    );

    this.colorsComponentSubscription = this.mdw.colorsComponentContainer$.subscribe(
      (data) => {
        if (data  && data.color_schema  && data.color_schema_ios && data.light !=null) {
          this.colors = data;
          this.light = data.light
        }
      })

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton && this.button_id &&
          data.currentButton.button_id == this.button_id
          && data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
           this.buttonFunction()

          }
        }
    );
  }

 intialize(data) {
  this.isAndroid = localStorage.getItem("mode")[0] == c1.ANDROID ? true : false;

  this.data = data.data;
    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }
  buttonFunction(){
    if (this.button){
  if (this.button.button_color_schema && this.button.button_color_schema.schemes.light && this.button.button_color_schema.schemes.light.bgstart){
      this.start_color = this.button.button_color_schema.schemes.light.bgstart ;

  }else {

   let initstart = this.config.colors.color_schema.schemes.light[this.config.init_start]
   this.start_color = initstart
   this.button = { ...this.button, button_color_schema: { schemes: {light: { ['bgstart']: initstart },dark: { ['bgstart']: initstart }, }, },  };
   this.button = { ...this.button, button_color_schema_ios: { schemes: {light: { ['bgstart']: initstart },dark: { ['bgstart']: initstart }, }, },  };
}


  if (this.button.button_color_schema && this.button.button_color_schema.schemes.light && this.button.button_color_schema.schemes.light.bgend){
  this.end_color = this.button.button_color_schema.schemes.light.bgend;
  }else {

  let initend = this.config.colors.color_schema.schemes.light[this.config.init_end]
  this.end_color = initend
  this.button = { ...this.button, button_color_schema: { schemes: {light: { ['bgend']: initend },dark: { ['bgend']: initend }, }, },  };
  this.button = { ...this.button, button_color_schema_ios: { schemes: {light: { ['bgend']: initend },dark: { ['bgend']: initend }, }, },  };

  }
    }
  }
  buttonBgColor(item,value, manule) {
    let color=manule ? value.target.value : value;
    if (item==='start') {
    if (this.button.button_color_schema &&  this.button.button_color_schema.schemes ) {
        const schemes = this.button.button_color_schema.schemes;
        let button_color_light = schemes.light;
        button_color_light = {...button_color_light, ['bgstart']: color, };
        let button_color_dark = schemes.dark;
        button_color_dark = {...button_color_dark, ['bgstart']: color,   };
        this.button.button_color_schema.schemes = { light: { ...button_color_light }, dark: { ...button_color_dark },     };
      } else {
          this.button = { ...this.button, button_color_schema: { schemes: {light: { ['bgstart']: color },dark: { ['bgstart']: color },
              },
            },
          };
        }

  if (this.button.button_color_schema_ios &&  this.button.button_color_schema_ios.schemes ) {
        const schemes = this.button.button_color_schema_ios.schemes;
        let button_color_light = schemes.light;
        button_color_light = {...button_color_light, ['bgstart']: color, };
        let button_color_dark = schemes.dark;
        button_color_dark = {...button_color_dark, ['bgstart']: color,   };
        this.button.button_color_schema_ios.schemes = { light: { ...button_color_light }, dark: { ...button_color_dark },     };
      } else {
          this.button = { ...this.button, button_color_schema_ios: { schemes: {light: { ['bgstart']: color },dark: { ['bgstart']: color },
              },
            },
          };
        }
     }
    if (item=== 'end'){
         if (this.button.button_color_schema &&  this.button.button_color_schema.schemes ) {
        const schemes = this.button.button_color_schema.schemes;
        let button_color_light = schemes.light;
        button_color_light = {...button_color_light, ['bgend']: color, };
        let button_color_dark = schemes.dark;
        button_color_dark = {...button_color_dark, ['bgend']: color,   };
        this.button.button_color_schema.schemes = { light: { ...button_color_light }, dark: { ...button_color_dark },     };
      } else {
          this.button = { ...this.button, button_color_schema: { schemes: {light: { ['bgend']: color },dark: { ['bgend']: color },
              },
            },
          };
        }

  if (this.button.button_color_schema_ios &&  this.button.button_color_schema_ios.schemes ) {
        const schemes = this.button.button_color_schema_ios.schemes;
        let button_color_light = schemes.light;
        button_color_light = {...button_color_light, ['bgend']: color, };
        let button_color_dark = schemes.dark;
        button_color_dark = {...button_color_dark, ['bgend']: color,   };
        this.button.button_color_schema_ios.schemes = { light: { ...button_color_light }, dark: { ...button_color_dark },     };
      } else {
          this.button = { ...this.button, button_color_schema_ios: { schemes: {light: { ['bgend']: color },dark: { ['bgend']: color },
              },
            },
          };
        }
     }
    this.updateButtonData()
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true
    );
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
       if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
  }
}
